import React from "react";
import { ChevronDownIcon } from "lucide-react";
import { SidebarGroup, SidebarGroupLabel, SidebarGroupContent, SidebarGroupAction } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

interface SidebarCollapsibleGroupProps {
	label: React.ReactNode;
	defaultOpen?: boolean;
	children: React.ReactNode;
}

export function SidebarCollapsibleGroup({ label, defaultOpen = true, children }: SidebarCollapsibleGroupProps) {
	const [open, setOpen] = React.useState(defaultOpen);

	const toggle = () => setOpen(o => !o);

	return (
		<SidebarGroup data-state={open ? "open" : "closed"}>
			<SidebarGroupLabel onClick={toggle} className="cursor-pointer pr-6">
				{label}
			</SidebarGroupLabel>
			<SidebarGroupAction onClick={toggle}>
				<ChevronDownIcon className={cn("transition-transform", !open && "-rotate-90")} />
			</SidebarGroupAction>
			{open && <SidebarGroupContent>{children}</SidebarGroupContent>}
		</SidebarGroup>
	);
}
